<template>
  <div class="home">
    <section class="hero">
      <div class="container">
        <div class="content-box">
          <h1 class="hero-title">אז מה יש לאולפן להציע לך?</h1>
          <div class="hero-content">
            <p>
              הפקת שיר מקורי (סינגל) משלב הסקיצה ועד לעיבוד מלא כם כל כלי הנגינה.
              הקלטת קאברים (לשירים מוכרים) , שיר במתנה , שיר בהפתעה , בר/בת מצווה ,
              ברכת כלה / חתן ועוד...
            </p>
            
            <p>
              יוצרים ? אם אתם כותבים ו/או מלחינים שירים - הגעתם למקום הנכון. באולפן
              ההקלטות שביסעור תוכלו לבנות עיבודים מההתחלה לשירים המקוריים שיצרתם.
            </p>
            
            <p class="highlight">
              הפקה מוזיקלית עם כל הנשמה!
            </p>
            
            <p>
              ולא פחות חשוב - עם ציוד סאונד מקצועי מהאקורד הראשון ועד לתו האחרון.
              הקלטות שירה / גיטרות / כלי מיתר / תופים / ועוד.
            </p>
            
            <p>
              תוכל להתרשם <router-link to="/productions" class="text-link">בהפקות</router-link>
              שעובדו והוקלטו פה באולפן. אז מחכים
              <router-link to="/contact" class="text-link">שתצרו קשר</router-link>
            </p>
          </div>
        </div>
      </div>
    </section>
    
    <section class="studio-showcase">
      <div class="container">
        <h2 class="section-title">האולפן שלנו</h2>
        <div class="studio-grid">
          <div class="studio-image">
            <img 
              src="/img/webp/S1.webp"
              alt="Studio View E"
              width="600" 
              height="400"
              class="visible-image"
            />
          </div>     
          <div class="studio-image">
            <img 
              src="/img/webp/S5.webp"
              alt="Studio View E" 
              width="600" 
              height="400"
              class="visible-image"
            />
          </div>
          <div class="studio-image">
            <img 
              src="/img/webp/StudioA.webp"
              alt="Studio View A" 
              width="600" 
              height="400"
              class="visible-image"
            />
          </div>
          <div class="studio-image">
            <img 
              src="/img/webp/StudioB.webp"
              alt="Studio View B" 
              width="600" 
              height="400"
              class="visible-image"
            />
          </div>
          <div class="studio-image">
            <img 
              src="/img/webp/StudioC.webp"
              alt="Studio View C" 
              width="600" 
              height="400"
              class="visible-image"
            />
          </div>
          <div class="studio-image">
            <img 
              src="/img/webp/StudioD.webp"
              alt="Studio View D" 
              width="600" 
              height="400"
              class="visible-image"
            />
          </div>
        
          <div class="studio-image">
            <img 
              src="/img/webp/S2.webp"
              alt="Studio View E" 
              width="600" 
              height="400"
              class="visible-image"
            />
          </div>       
          <div class="studio-image">
            <img 
              src="/img/webp/S3.webp"
              alt="Studio View E" 
              width="600" 
              height="400"
              class="visible-image"
            />
          </div>     
          <div class="studio-image">
            <img 
              src="/img/webp/S4.webp"
              alt="Studio View E" 
              width="600" 
              height="400"
              class="visible-image"
            />
          </div>    
          <div class="studio-image">
            <img 
              src="/img/logo.png"
              alt="Studio Logo" 
              width="600" 
              height="400"
              class="visible-image"
            />
          </div>       
        </div>        
      </div>
    </section>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "Home",
  data() {
    return {};
  },
  mounted() {
    // Add font preloading if you have custom fonts
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        document.documentElement.classList.add('fonts-loaded');
      });
    }
    
    // Prefetch future routes for better navigation performance
    setTimeout(() => {
      // Use router.resolve to get the full path and append it to the base URL
      // This prevents direct HTTP requests to /productions and /contact
      const prefetchRoutes = [
        { name: 'Productions' },
        { name: 'Contact' }
      ];
      
      prefetchRoutes.forEach(route => {
        try {
          const resolvedRoute = this.$router.resolve(route);
          if (resolvedRoute && resolvedRoute.href) {
            // Create prefetch link
            const link = document.createElement('link');
            link.rel = 'prefetch';
            // Make sure we're using a relative path
            link.href = resolvedRoute.href;
            document.head.appendChild(link);
            console.log(`Prefetched: ${resolvedRoute.href}`);
          }
        } catch (err) {
          console.warn(`Failed to prefetch route ${route.name}:`, err);
        }
      });
    }, 2000); // Delay prefetching to prioritize initial page load
  }
});
</script>

<style scoped>
.home {
  direction: rtl;
}

.hero {
  min-height: 70vh;
  background-image: linear-gradient(rgba(4, 9, 30, 0.8), rgba(4, 9, 30, 0.7)), 
                    url('~@/assets/studio1.jpg');
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center;
  text-align: right;
  padding: 4rem 0;
  will-change: transform; /* Hint for browser optimization */
}

.container {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
}

.content-box {
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  border-radius: 10px;
  padding: 2.5rem;
  color: var(--light-text);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  max-width: 800px;
  margin: 0 auto;
}

.hero-title {
  font-size: 2.5rem;
  margin-bottom: 2rem;
  position: relative;
  color: var(--light-text);
  font-weight: 700;
}

.hero-title::after {
  content: '';
  position: absolute;
  bottom: -15px;
  right: 0;
  width: 100px;
  height: 4px;
  background: var(--accent-color);
}

.hero-content {
  font-size: 1.1rem;
  line-height: 1.8;
}

.hero-content p {
  margin-bottom: 1.5rem;
}

.highlight {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--accent-color);
  margin: 2rem 0;
  text-align: center;
}

.text-link {
  color: var(--accent-color);
  font-weight: 600;
  transition: all 0.3s ease;
  position: relative;
}

.text-link::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background: var(--accent-color);
  transform: scaleX(0);
  transition: transform 0.3s ease;
  transform-origin: right;
}

.text-link:hover::after {
  transform: scaleX(1);
  transform-origin: left;
}

.studio-showcase {
  padding: 5rem 0;
  background-color: var(--light-bg);
}

.section-title {
  text-align: center;
  font-size: 2.2rem;
  margin-bottom: 3rem;
  color: var(--dark-bg);
  position: relative;
  display: inline-block;
  left: 50%;
  transform: translateX(-50%);
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 70px;
  height: 3px;
  background: var(--accent-color);
}

.studio-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.studio-image {
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
  position: relative;
  contain: layout paint; /* Helps with performance */
}

.studio-image:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
}

/* Important fix - make images visible by default */
.studio-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  opacity: 1; /* Important: Set opacity to 1 to ensure visibility */
  transition: transform 0.5s ease;
}

.visible-image {
  opacity: 1 !important; /* Ensure images are visible */
}

.studio-image:hover img {
  transform: scale(1.05);
}

@media (max-width: 1200px) {
  .studio-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
  
  .studio-image {
    height: 250px;
  }
}

@media (max-width: 768px) {
  .hero {
    min-height: 50vh;
    padding: 2rem 0;
  }
  
  .content-box {
    padding: 1.5rem;
  }
  
  .hero-title {
    font-size: 1.8rem;
  }
  
  .hero-content {
    font-size: 1rem;
  }
  
  .highlight {
    font-size: 1.2rem;
  }
  
  .studio-grid {
    grid-template-columns: 1fr;
  }
  
  .studio-image {
    height: 200px;
  }
  
  .section-title {
    font-size: 1.8rem;
  }
}

@media print {
  .studio-image {
    break-inside: avoid;
    page-break-inside: avoid;
  }
}
</style>

